import {
  AllocationStatus,
  InvoiceStatus,
  PaymentStatus,
} from 'pages/invoices/components/filters/filters.types';

export type InvoicesParams = {
  own: boolean;
  resultSize: number;
  pageNumber: number;
  administrative: boolean;
  np?: boolean;
  invoiceStatus?: InvoiceStatus;
  status?: PaymentStatus;
  filterText?: string;
  startDate?: Date;
  endDate?: Date;
  allocationStatus?: AllocationStatus;
  excludeCorrective?: boolean;
  excludeDeleted?: boolean;
  published?: boolean;
  invoiceType?: string;
  forCorrectiveCreate?: boolean;
  hasCorrectiveInvoice?: boolean;
  sortProperty?: string;
  onlyMine?: boolean;
  sortDirection?: SortDirection;
};

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
